const FamilyBar = () => {
    return (
        <aside id="nkr-familybar">
            <nav>
                <span>
                    <svg
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 30 30"
                    >
                        <path
                            fill="#c8102e"
                            d="M4.951,19.417a7.927,7.927,0,0,0,10.356-4.289,7.262,7.262,0,1,1,13.418,5.558A14.857,14.857,0,0,1,.207,13.614,7.926,7.926,0,0,0,4.951,19.417Zm24.842-3.03a7.924,7.924,0,0,0-15.1-1.514A7.262,7.262,0,1,1,1.275,9.315a14.857,14.857,0,0,1,28.518,7.072Z"
                        />
                        <path
                            fill="#fff"
                            d="M25.3,9.97a8.584,8.584,0,0,0-11.224,4.649A6.6,6.6,0,0,1,1.889,9.57,14.156,14.156,0,0,1,15.006.805h0a14.206,14.206,0,0,1,13.1,8.765,14.309,14.309,0,0,1,.941,3.4A8.538,8.538,0,0,0,25.3,9.97Z"
                        />
                    </svg>
                    The NKR Network
                </span>
                <ul>
                    <li>
                        <a href="https://www.kidneyregistry.com" target="_blank" rel="noreferrer">
                            National Kidney Registry
                        </a>
                    </li>
                    <li>
                        <a href="https://www.donorshield.com/" target="_blank" rel="noreferrer">
                            Donor Shield
                        </a>
                    </li>
                    <li>
                        <a href="https://www.choosedonation.com/" target="_blank" rel="noreferrer">
                            Choose Donation
                        </a>
                    </li>
                    <li>
                        <a href="https://www.donorcarenet.com/" target="_blank" rel="noreferrer">
                            Donor Care Network
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.kidneytransplantcenters.com/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Kidney Transplant Centers
                        </a>
                    </li>
                    <li>
                        <a href="https://www.kidneyforlife.com/" target="_self">
                            Kidney for Life
                        </a>
                    </li>
                    <li>
                        <a href="https://www.findakidney.com/" target="_blank" rel="noreferrer">
                            Find A Kidney
                        </a>
                    </li>
                    <li>
                        <a href="https://www.livingdonorgames.org/" target="_self">
                            Donor Games
                        </a>
                    </li>
                </ul>
            </nav>
        </aside>
    );
}

export default FamilyBar;